<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            <p>Die Großform des Experimentalbaus "Hybrid" besteht aus einem Möbiuskörper. Dieser fasziniert durch seine scheinbar unendliche Form, da dieser nur eine Fläche und eine Kante besitzt, welche in sich selbst zurücklaufen. Ein Experimentierfeld in dem es kein klares Oben und Unten gibt. Die scheinbare Decke windet sich, wird mit der Bewegung durch den Pavillon zu Wand und zu Boden. Die klassischen Architekturelemente Dach, Wand und Boden werden aufgehoben - es entsteht ein Raumkontinuum. Die auf Gehrung geschnittenen Eckverbindungen, der in einem Winkel aufeinandertreffenden Bauteile wurden an der 5-Achs-Fräse gefertigt. Die Kontakt- und Verbindungsfläche wird dadurch vergrößert. Die komplexe 3D-Struktur wurde parametrisch generiert und auf Basis eines komplett durchdetailierten CNC-Datensatzes im CNC-Lab gefertigt. </p>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(3)"
            :link="links[3]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(6)"
            :link="links[6]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf und Realisierung</p>
            <p>Vasiliki Corakas, Ayla Ertürk, Annalena Kluge, Steffen Reiter, Marc Ulm, Xiaojia Yao, Steven Kaufmann, Lilli Lisitchkina, Judith Weber, Julian Staubach</p>
            <br>
            <p class="font-semibold">Betreuung</p>
            <p>Prof. Dr. Markus Holzbach,
                HfG Offenbach am Main
                in Kooperation mit
                Prof. Dr. Patrick Teuffel,
                TU Delft
                Parametric Strategies
                Xing Wang,
                Hyperbody-research group TU Delft
                Andreas Schnubel,
                Rice-Francis–Ritchie RFR - Paris
                5-Achs-Fräse / 3D-Zuschnitt
                Wolfgang Heide, HfG Offenbach
            </p>
        </span>
    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/1-2.jpg' ),
                require( '@/assets/img/pc/Hybrid-D-3.jpg' ),
                require( '@/assets/img/pc/Hybrid-D-6.jpg' ),
                require( '@/assets/img/pc/DSC_6580.jpg' ),
                require( '@/assets/img/pc/Hybrid-D-7.jpg' ),
                require( '@/assets/img/pc/Hybrid-D-8.jpg' ),
                require( '@/assets/img/pc/Hybrid-D-1.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>